import * as React from "react";
import "./failureMessage.css";
import "../../../style/fonts.css";

export interface Props {
  text: string;
}

class FailureMessage extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.text) {
      return (
        <div className="FAILURE_MESSAGE_CONT">
          <div className="FAILURE_MESSAGE">
            <div className="SMALL_TEXT2">{this.props.text}</div>
          </div>
        </div>
      );
    } else return null;
  }
}

export default FailureMessage;



// WEBPACK FOOTER //
// ./src/components/input/failureMessage/failureMessage.tsx